import { createAction, createReducer } from '@reduxjs/toolkit';

export interface ConnectionState {
  readonly userId: string | null;
  readonly serverTime: string | null;
}

export const initialConnectionState: ConnectionState = {
  userId: null,
  serverTime: null,
};

export const setUserId = createAction<string>('SET_USER_ID');
export const setServerTime = createAction<string>('SET_SERVER_TIME');

export const connectionReducer = createReducer(initialConnectionState, (builder) => {
  builder
    .addCase(setUserId, (state, action) => {
      state.userId = action.payload;
    })
    .addCase(setServerTime, (state, action) => {
      state.serverTime = action.payload;
    });
});
